import React, { useState, useEffect, useRef } from 'react'
import { ChevronDown, FileQuestion } from 'lucide-react'
import { Divider } from '@mui/material'


export default function CustomDropdown({ title, data, onSelect, defaultValue, icon, textKey, rows = false }) {
  const [isOpen, setIsOpen] = useState(false)
  const [selected, setSelected] = useState(null)
  const dropdownRef = useRef(null)

  const dataObject = Array.isArray(data?.rows)
    ? data.rows
    : Array.isArray(data)
      ? data
      : [];


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])


  const handleSelect = (item) => {
    setSelected(item)
    setIsOpen(false)
    onSelect(item)
  }


  return (
    <div ref={dropdownRef} className="relative w-full min-w-[200px]">
      <button
        className="flex items-center justify-between w-full p-3 text-left bg-white border border-gray-300 rounded-[12px] shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-500"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center">
          <span className="w-6 h-6 text-purple-500"> {icon}</span>
          <Divider orientation="vertical" flexItem style={{ margin: '0px 8px' }} />
          <div>
            <div className="font-medium text-sm">{title}</div>
            <div className="text-sm text-gray-500">{defaultValue ? defaultValue : selected ? selected?.[textKey] : 'Select'}</div>
          </div>
        </div>
        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {dataObject?.map((item) => (
            <div
              key={item.id}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${selected && selected.id === item.id ? 'bg-purple-100' : ''
                }`}
              onClick={() => handleSelect(item)}
            >
              {item?.[textKey]}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}